import Vue from 'vue'
import store from '../store'
import router from "../router";
import axios from 'axios'
import {v4 as uuidv4} from 'uuid'

export default {
  // 下载 zip
  downloadZip(url) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url,
        responseType: 'arraybuffer'
      }).then(data => {
        resolve(data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 上传
  ossUpload(data) {
    const fileName = this.makeRandomName(data)
    return new Promise((resolve) => {
      Vue.prototype.$requestApi.api.resource({original_name: data.name}).then(res => {
        const response = res
        const info = {}
        info['x:original_name'] = data.name
        info['x:source_type'] = 'User'
        info['x:category_id'] = data.category_id
        info['x:created_by'] = JSON.parse(localStorage.getItem("user-info")).id
        info['x:video_second'] = data.video_time ? data.video_time : ''
        info.policy = response.policy
        info.OSSAccessKeyId = response.accessid
        info.signature = response.signature
        info.host = response.host
        info.callback = response.callback
        info.key = response.dir + fileName
        resolve(info);
      })
    })
  },
  // 上传文件随机名称
  makeRandomName(value) {
    const suffix = value.name.substr(value.name.lastIndexOf('.'))  //获取该文件类型
    return new Date().getTime() + '-' + uuidv4() + suffix
  },
  // 拉取个人信息
  info() {
    return new Promise(() => {
      Vue.prototype.$requestApi.api.userInfo().then(res => {
        localStorage.setItem('user-info', JSON.stringify(res.data))
        store.state.status.message_count = res.data.notification_count
        location.reload()
      })
    })
  },
  // 判断是否登录
  loginStatus() {
    const token = localStorage.getItem('Authorization')
    if (!token) {
      store.state.status.login = true
      return false
    } else return true
  },
  // 收藏
  upCollect(data) {
    Vue.prototype.$requestApi.index.getUserCollect({
      type: data.type,
      source_id: data.id
    })
  },
  // 点赞
  upLike(data) {
    Vue.prototype.$requestApi.index.getUserLike(data)
  },
  // 关注
  upFollower(data) {
    Vue.prototype.$requestApi.index.getFollow({follower_id: data, follower_type: 'user'})
  },
  // 发送私信
  sendMessage(data) {
    Vue.prototype.$requestApi.message.sendMessage({
      to_type: data.type,
      to_user: data.id,
      message: ''
    }).then(res => router.push({name: "message", query: {category: "private_letter", id: data.id, type: data.type}}))
  },
  /* 设计师主页 */
  handleGetDesignerHome(id) {
    router.push({name: "designer_detail", query: {id: id}})
  },
  /* 专家主页 */
  handleExpertHome(id) {
    router.push({name: "expert_home", query: {id: id}})
  }
}



// WEBPACK FOOTER //
// ./src/utils/public.js